const DEFAULT_BASE_URL = 'https://panel.zoodkomak.com/ZkpWebService'

function stripTrailingSlash (value) {
  return value ? value.replace(/\/+$/, '') : ''
}

function envUrl (key, fallback) {
  const value = process.env[key]
  if (!value || value === '/') return fallback

  return stripTrailingSlash(value)
}

const baseURL = envUrl('VUE_APP_BASE_URL', envUrl('BASE_URL', DEFAULT_BASE_URL))
const panelURL = baseURL.replace(/\/ZkpWebService$/i, '')

export const apiUrls = {
  baseURL,
  panelURL,
  jetTokenURL: `${panelURL}/jetToken`,
  panelApiURL: `${panelURL}/api`,
  cpApiURL: envUrl('VUE_APP_CP_API_URL', 'https://cp.zoodkomak.com/api'),
  payURL: envUrl('VUE_APP_PAY_URL', 'https://pay.zoodkomak.com'),
  payApiURL: envUrl('VUE_APP_PAY_API_URL', 'https://pay.zoodkomak.com/api'),
  reportApiURL: envUrl('VUE_APP_REPORT_API_URL', 'https://rpt.zoodkomak.com/api'),
  signalrURL: `${panelURL}/signalr`
}

export function apiUrl (base, path = '') {
  return `${stripTrailingSlash(base)}/${String(path).replace(/^\/+/, '')}`
}

export function rewriteLegacyApiUrl (url) {
  if (typeof url !== 'string') return url

  const replacements = [
    ['https://panel.zoodkomak.com/ZkpWebService', apiUrls.baseURL],
    ['https://test.zoodkomak.com/ZkpWebService', apiUrls.baseURL],
    ['https://panel.zoodkomak.com/jetToken', apiUrls.jetTokenURL],
    ['https://panel.zoodkomak.com/api', apiUrls.panelApiURL],
    ['https://cp.zoodkomak.com/api', apiUrls.cpApiURL],
    ['https://pay.zoodkomak.com/api', apiUrls.payApiURL],
    ['https://pay.zoodkomak.com', apiUrls.payURL],
    ['https://rpt.zoodkomak.com/api', apiUrls.reportApiURL],
    ['https://panel.zoodkomak.com/signalr', apiUrls.signalrURL]
  ]

  const replacement = replacements.find(([legacyURL]) => url.indexOf(legacyURL) === 0)
  if (!replacement) return url

  const [legacyURL, configuredURL] = replacement
  return `${stripTrailingSlash(configuredURL)}${url.slice(legacyURL.length)}`
}
